import { Outlet } from "react-router-dom";
import TopBar from "../components/TopBar";
import SideMenu from "../components/SideMenu";

export default function POSLayout() {
  return (
    <div className="h-screen flex bg-gray-100">
      {/* DESKTOP SIDEMENU */}
      
      <aside className="hidden md:block w-64 bg-white border-r fixed h-full">
        <SideMenu />
      </aside>

      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col md:ml-64">
        <TopBar />
        <main className="flex-1 overflow-y-auto hide-scrollbar">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
